import produce from 'immer'
import * as actionTypes from '../constants/actionTypes'

const initialState = {}

export function appReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SELECT_DASHBOARD_FILTER_TAB:
      return produce(state, draft => {
        draft.selectedDashboardFilterTab = action.payload
      })

    case actionTypes.MOVE_ANSWER:
    case actionTypes.MOVE_STEP:
    case actionTypes.UPDATE_STEP_PROPERTIES:
    case actionTypes.UPDATE_BOT_PROPERTIES:
    case actionTypes.STEP_ACTION:
    case actionTypes.ADD_STEP:
    case actionTypes.RENAME_DIALOG:
    case actionTypes.DELETE_STEP:
      return {
        ...state
      }

    case actionTypes.SAVE_BOT:
      return { ...state, saving: true }
    case actionTypes.SAVE_BOT_SUCCESS:
      return { ...state, saving: undefined }
    case actionTypes.SAVE_BOT_FAILURE:
      return { ...state, saving: undefined }

    default:
      return state
  }
}
